import { Stack, styled, Typography } from "@mui/material";
import { primary } from "@/theme/colors";
import React, { forwardRef } from "react";

export const RoomHead = forwardRef<HTMLDivElement>((props, ref) => (
  <StyledRoomHead ref={ref} {...props}>
    <Typography sx={{ marginBottom: "4px" }} variant="sub16Bold">
      Irohana
    </Typography>
  </StyledRoomHead>
));

const StyledRoomHead = styled(Stack)`
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 16px;
  background-color: ${primary.main};
  color: white;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  height: 56px;
  min-height: 56px;
  max-height: 56px;
  flex-shrink: 0;
`;
